<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.asnDetailEdit" type="confirm" width="60%" @confirm="confirm">
    <vxe-form ref="form" :data="detail" :rules="rules" span="8">
      <vxe-form-item :itemRender="{name:'VxeInput',props:{disabled:true}}" field="item.no" title="business.label.itemNo"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{disabled:true}}" field="item.name" title="business.label.itemName"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>this.onPackSelect(),clear:()=>this.onPackChange([])}}" field="pack.specification" title="business.label.specification"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false}}" field="pack.uom" title="business.label.uom"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false}}" field="pack.factor" title="business.label.factor"/>
      <vxe-form-item field="lotNo" title="business.label.lot">
        <template #default>
          <vxe-input v-model="detail.lotNo" @dblclick.native="onLotSelect"/>
        </template>
      </vxe-form-item>
      <vxe-form-item :item-render="{name:'VxeDatePicker'}" field="productionDate" title="business.label.productionDate"/>
      <vxe-form-item :item-render="{name:'VxeDatePicker'}" field="validUntil" title="business.label.validUntil"/>
      <vxe-form-item :item-render="{name:'VxeSelect',options:manufacturers}" field="manufacturer" title="business.label.manufacturer"/>
      <vxe-form-item :item-render="{name:'VxeSelect',options:producingAreas}" field="producingArea" title="business.label.producingArea"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>onApprovalNoSelect()}}" field="approvalNo" title="business.label.approvalNo"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>onLicenseSelect(),clear:()=>onLicenseChange([])}}" field="license.licenseNo" title="business.label.licenseNo"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>onPermissionSelect(),clear:()=>onPermissionChange([])}}" field="permission.permissionNo" title="business.label.permissionNo"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>onPracticeSelect(),clear:()=>onPracticeChange([])}}" field="practice.practiceNo" title="business.label.practiceNo"/>
      <vxe-form-item :itemRender="{name:'VxeInput',props:{editable:false},events:{click:()=>onQualitySelect(),clear:()=>onQualityChange([])}}" field="quality.qualityStandard" title="business.label.qualityStandard"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="quantity" title="business.label.arrivalQuantity"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.departureTemp" title="business.label.departureTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.arrivalTemp" title="business.label.arrivalTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.maximumTemp" title="business.label.maximumTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.minimumTemp" title="business.label.minimumTemp"/>
    </vxe-form>
    <pack-modal ref="packModal" @change="onPackChange"/>
    <lot-modal ref="lotModal" @change="onLotChange"/>
    <approval-modal ref="approvalModal" @change="onApprovalNoChange"/>
    <license-modal ref="licenseModal" @change="onLicenseChange"/>
    <permission-modal ref="permissionModal" @change="onPermissionChange"/>
    <practice-modal ref="practiceModal" @change="onPracticeChange"/>
    <quality-modal ref="qualityModal" @change="onQualityChange"/>
  </vxe-modal>
</template>

<script>
import api from '@/api'
import { post } from '@/api/Api'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import { Pack } from '@/api/dto/common/Pack'
import { License } from '@/api/dto/valueobject/License'
import { Practice } from '@/api/dto/valueobject/Practice'
import { Permission } from '@/api/dto/valueobject/Permission'
import { Quality } from '@/api/dto/valueobject/Quality'
import PackModal from '@/views/modal/PackModal.vue'
import LotModal from '@/views/modal/LotModal.vue'
import ApprovalModal from '@/views/inbound/asn/modal/ApprovalModal.vue'
import LicenseModal from '@/views/inbound/asn/modal/LicenseModal.vue'
import PermissionModal from '@/views/inbound/asn/modal/PermissionModal.vue'
import PracticeModal from '@/views/inbound/asn/modal/PracticeModal.vue'
import QualityModal from '@/views/inbound/asn/modal/QualityModal.vue'

export default {
  components: { ApprovalModal, LicenseModal, LotModal, PackModal, PermissionModal, PracticeModal, QualityModal },
  data() {
    return {
      visible: false,
      loading: false,
      order: new AsnOrder(),
      detail: new AsnDetail(),
      manufacturers: [],
      producingAreas: [],
      rules: {
        'pack.specification': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'lotNo': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'productionDate': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'validUntil': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'manufacturer': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'producingArea': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'quantity': [{ required: true, min: 1, type: 'number', message: '数量需大于0' }]
      }
    }
  },
  methods: {
    open(order, detail) {
      this.visible = true
      this.order = order
      this.detail = detail
      this.manufacturers = detail.item.manufacturer.split(',').map(item => {
        return { value: item, label: item }
      })
      this.producingAreas = detail.item.producingArea.split(',').map(item => {
        return { value: item, label: item }
      })
    },
    onPackSelect() {
      this.$refs.packModal.open({ 'item.id': this.detail.item.id })
    },
    onPackChange(values) {
      this.detail.pack = new Pack(values[0])
    },
    onLotSelect() {
      this.$refs.lotModal.open({ 'item.id': this.detail.item.id })
    },
    onLotChange(values) {
      const value = values[0]
      this.detail.lotNo = value.no
      this.detail.validUntil = value.validUntil
      this.detail.productionDate = value.productionDate
      this.detail.manufacturer = value.manufacturer
      this.detail.producingArea = value.producingArea
      this.detail.approvalNo = value.approvalNo
      this.detail.license = new License(value.license)
      this.detail.practice = new Practice(value.practice)
      this.detail.permission = new Permission(value.permission)
      this.detail.quality = new Quality(value.quality)
    },
    onApprovalNoSelect() {
      this.$refs.approvalModal.open({ 'itemId': this.detail.item.id })
    },
    onApprovalNoChange(values) {
      this.$nextTick(() => {
        this.detail.approvalNo = values[0].approvalNo
      })
    },
    onLicenseSelect() {
      this.$refs.licenseModal.open({ 'itemId': this.detail.item.id })
    },
    onLicenseChange(values) {
      this.detail.license = new License(values[0])
    },
    onPermissionSelect() {
      this.$refs.permissionModal.open({ 'itemId': this.detail.item.id })
    },
    onPermissionChange(values) {
      this.detail.permission = new Permission(values[0])
    },
    onPracticeSelect() {
      this.$refs.practiceModal.open({ 'itemId': this.detail.item.id })
    },
    onPracticeChange(values) {
      this.detail.practice = new Practice(values[0])
    },
    onQualitySelect() {
      this.$refs.qualityModal.open({ 'itemId': this.detail.item.id })
    },
    onQualityChange(values) {
      this.detail.quality = new Quality(values[0])
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.details = [this.detail.toJSONObject()]
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success', res.result)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    }
  }
}
</script>